module.exports = __webpack_public_path__ + "static/media/BA.54600434.svg";